<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Instructions",
  data() {
    return {
      activeTab: 1,
      tabs: [
        {
          id: 1,
          title: "Project Overview",
          content:
            "View and manage project details, including project name, budget allocation, and current status. Update project information as needed.",
        },
        {
          id: 2,
          title: "Database",
          content:
            "View and manage project team members. Add new team members, update existing ones, and remove inactive members.",
        },
        {
          id: 3,
          title: "Expense (Cash/ Bank)",
          content:
            "Track and record all project expenses. Add new expenses with details such as amount, category, date, and supporting documentation.",
        },
        {
          id: 4,
          title: "Cheques",
          content:
            "View all issued cheques for the project. Monitor cheque status, amounts, and recipient details.",
        },
        {
          id: 5,
          title: "Project overview",
          content:
            "View all invoices issued for the project. Track invoice status, amounts, and recipient details.",
        },
        {
          id: 6,
          title: "Bank to Cash",
          content:
            "Manage bank and cash transactions. Record deposits, withdrawals, and transfers between accounts.",
        },
        {
          id: 7,
          title: "Currency",
          content:
            "Handle currency exchange transactions. Record exchange rates, amounts, and conversion details.",
        },
        {
          id: 8,
          title: "Income (Cash/ Bank)",
          content:
            "Create new cheque entries or update existing ones. Fill in cheque number, amount, payee, and date information.",
        },
        {
          id: 9,
          title: "Project funds",
          content:
            "Create new invoice entries or update existing ones. Fill in invoice number, amount, payee, and date information.",
        },
        {
          id: 10,
          title: "Definition (Budget positions)",
          content:
            "View all fund requests submitted for this project. Track request status and approval history.",
        },
        {
          id: 11,
          title: "To do",
          content:
            "View all approved fund requests for this project. Track request status and approval history.",
        }
      ],
    };
  },
  computed: {
    activeTabContent() {
      return this.tabs.find((tab) => tab.id === this.activeTab);
    },
  },
  methods: {
    setActiveTab(id) {
      this.activeTab = id;
    },
  },
});
</script>

<template>
  <div class="instructions-container">
    <div class="instructions-layout">
      <!-- Left sidebar with tabs -->
      <div class="flex flex-col gap-4 max-w-[200px] bg-white rounded-lg p-3">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          :class="['tab-button !text-left', { active: activeTab === tab.id }]"
          @click="setActiveTab(tab.id)"
        >
<!--          <span class="tab-number">{{ tab.id }}</span>-->
          <span>{{ tab.title }}</span>
        </button>
      </div>

      <!-- Right content area -->
      <div>
        <div v-if="activeTabContent" class="content-card">
          <h3 class="text-2xl font-semibold text-center">{{ activeTabContent.title }}</h3>
          <hr class="mt-4 mb-8">
          <p class="content-text">{{ activeTabContent.content }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.instructions-container {
  padding: 20px 0;
}

.instructions-title {
  font-size: 24px;
  font-weight: 600;
  color: #101828;
  margin-bottom: 8px;
}

.instructions-subtitle {
  font-size: 14px;
  color: #667085;
  margin-bottom: 24px;
}

.instructions-layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

.tab-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.tab-item:hover {
  background-color: #f9fafb;
  border-color: #d0d5dd;
}

.tab-item.active {
  background-color: #f9fafb;
  border-color: #344054;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.tab-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #f2f4f7;
  color: #344054;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.tab-item.active .tab-number {
  background-color: #344054;
  color: #ffffff;
}

.tab-title {
  font-size: 14px;
  font-weight: 500;
  color: #344054;
  line-height: 1.4;
}

.content-area {
  flex: 1;
  min-height: 300px;
}

.content-card {
  background: #ffffff;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  padding: 24px;
}

.content-title {
  font-size: 20px;
  font-weight: 600;
  color: #101828;
  margin-bottom: 16px;
}

.content-text {
  font-size: 14px;
  color: #667085;
  line-height: 1.6;
  margin: 0;
}

@media (max-width: 768px) {
  .instructions-layout {
    flex-direction: column;
  }
}
</style>
